<template>
  <!-- Layout con .page-container per coerenza con altre pagine -->
  <main id="create-client-page" class="page-container">
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Form principale -->
    <form class="create-client-form" @submit.prevent="onUpdateClient">
      <!-- RIGA 1: Nome Cliente, Ragione Sociale -->
      <div class="create-client-row row-1">
        <div class="field">
          <label for="client-name">Nome cliente</label>
          <input
            id="client-name"
            type="text"
            v-model="formData.clientName"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="business-name">Ragione sociale</label>
          <input
            id="business-name"
            type="text"
            v-model="formData.companyName"
            placeholder="inserisci"
            required
          />
        </div>
      </div>

      <hr />

      <!-- RIGA 2: P.IVA, PEC, Codice univoco, Sede Legale -->
      <div class="create-client-row row-2">
        <!-- Partita IVA -->
        <div class="field">
          <label for="vat-number">P.IVA</label>
          <input
            id="vat-number"
            type="text"
            v-model="formData.vatNumber"
            placeholder="inserisci"
          />
        </div>

        <!-- PEC -->
        <div class="field">
          <label for="pec">Pec</label>
          <input
            id="pec"
            type="email"
            v-model="formData.pec"
            placeholder="inserisci"
          />
        </div>

        <!-- Codice Univoco -->
        <div class="field">
          <label for="unique-code">Codice univoco</label>
          <input
            id="unique-code"
            type="text"
            v-model="formData.uniqueCode"
            placeholder="inserisci"
          />
        </div>

        <!-- Sede Legale -->
        <div class="field">
          <label for="legal-address">Sede legale</label>
          <input
            id="legal-address"
            type="text"
            v-model="formData.legalHeadquarters"
            placeholder="inserisci"
          />
        </div>

        <!-- Bottone Salva allineato a destra -->
        <div class="save-button-container">
          <button id="create-client-button" type="submit">Aggiorna</button>
        </div>
      </div>

      <!-- <hr /> -->

      <!-- RIGA 3: Immagine -->
      <!-- <div class="create-client-row row-3">
        <div class="field">
          <label for="image">Immagine</label>
          <input
            id="image"
            type="file"
            @change="handleImageUpload"
            accept="image/*"
          />
        </div>
      </div> -->
    </form>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { useToast } from "vue-toast-notification";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },
  name: "EditClientPage",
  props: ["clientId"],
  data() {
    return {
      formData: {
        clientName: "",
        companyName: "",
        vatNumber: "",
        pec: "",
        uniqueCode: "",
        legalHeadquarters: "",
        // image: null,
      },
      // errorMessage: "",
      // successMessage: "",
    };
  },
  methods: {
    ...mapActions(["updateClient"]),

    /**
     * Recupera i dati dell'cliente da modificare.
     * Viene chiamato appena il componente è montato.
     */
    async fetchClientData() {
      try {
        // this.errorMessage = "";
        const response = await this.$axios.get(`client/${this.clientId}`);
        // console.log("client by id: ", response);
        // Adatta il percorso a seconda della tua API
        if (response.status === 200) {
          // Popola i campi con i dati ottenuti
          const clientData = response.data.client;
          this.formData.clientName = clientData.clientName;
          this.formData.companyName = clientData.companyName;
          this.formData.vatNumber = clientData.vatNumber;
          this.formData.pec = clientData.pec;
          this.formData.uniqueCode = clientData.uniqueCode;
          this.formData.legalHeadquarters = clientData.legalHeadquarters;
          // Se c'è un URL immagine, decidi se vuoi gestirlo in modo particolare
          // this.formData.image = clientData.image;

          // this.$nextTick(() => {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Dati cliente caricati con successo."
          );
          // });
        }
      } catch (error) {
        // this.errorMessage =
        this.toast.error(
          error.response?.data?.message ||
            "Impossibile caricare i dati del cliente."
        );
      }
    },

    // handleImageUpload(e) {
    //   const file = e.target.files[0];
    //   if (file) {
    //     this.formData.image = file;
    //   }
    // },

    async onUpdateClient() {
      try {
        // this.errorMessage = "";
        // this.successMessage = "";

        // Puoi usare un FormData se devi inviare anche file (immagine),
        // altrimenti un JSON semplice se l'API lo consente.
        const payload = {
          clientName: this.formData.clientName,
          companyName: this.formData.companyName,
          vatNumber: this.formData.vatNumber,
          pec: this.formData.pec,
          uniqueCode: this.formData.uniqueCode,
          legalHeadquarters: this.formData.legalHeadquarters,
          // immagine gestita a parte se necessario
        };

        // Esempio di richiesta PATCH
        const response = await this.updateClient({
          clientId: this.clientId,
          payload,
        });

        if (response.status === 200) {
          // this.$nextTick(() => {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Cliente aggiornato con successo!"
          );
          // });
          // redirect alla pagina clients
          setTimeout(() => {
            this.$router.push({ name: "customers" });
          }, 1000);
        }
      } catch (error) {
        // Se arrivi qui, c’è un errore => error.response esiste
        if (error.response?.status === 409) {
          // Gestisci il conflitto
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response.data?.details ||
              "Conflitto nei dati, chiave univoca 'Ragione sociale' già presente."
          );
          // });
        } else {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante l'aggiornamento del cliente."
          );
          // });
        }
        // this.successMessage = "";
      }
    },
  },
  /**
   * Appena montato, recupera i dati dall'API
   */
  mounted() {
    this.fetchClientData();
  },
};
</script>

<style src="@/css/CreateClientPage.css"></style>
